/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPrivacyResultItem } from './CRSFPrivacyResultItem';
import {
    CRSFPrivacyResultItemFromJSON,
    CRSFPrivacyResultItemFromJSONTyped,
    CRSFPrivacyResultItemToJSON,
} from './CRSFPrivacyResultItem';

/**
 * 
 * @export
 * @interface CRSFPrivacyPagedResponse
 */
export interface CRSFPrivacyPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFPrivacyPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFPrivacyPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFPrivacyResultItem>}
     * @memberof CRSFPrivacyPagedResponse
     */
    results?: Array<CRSFPrivacyResultItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFPrivacyPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFPrivacyPagedResponse interface.
 */
export function instanceOfCRSFPrivacyPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFPrivacyPagedResponseFromJSON(json: any): CRSFPrivacyPagedResponse {
    return CRSFPrivacyPagedResponseFromJSONTyped(json, false);
}

export function CRSFPrivacyPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFPrivacyResultItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFPrivacyPagedResponseToJSON(value?: CRSFPrivacyPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFPrivacyResultItemToJSON)),
        'total': value.total,
    };
}

